export const defaultColumns = [
  { label: 'Número de protocolo', value: 'protocol_number' },
  { label: 'Status', value: 'status' },
  { label: 'Equipamento', value: 'equipment' },
  { label: 'Filial', value: 'branch' },
  { label: 'Tipo de solicitação', value: 'kind' },
  { label: 'Programa de manutenção', value: 'maintenance_program' },
  { label: 'Regra atingida', value: 'rule_reached' },
  { label: 'Dt. e Hr.', value: 'created_at' },
  { label: 'Autor', value: 'author' },
  { label: 'Descrição', value: 'observations' },
  { label: 'Ação', value: 'action', className: 'w-9' },
]
